import { Drawer, Box, Button } from "@mui/material";
import React from "react";
import AvatarHeader from "./AvatarHeader";
import AvatarOptions from "./AvatarOptions";

//Componente seletor de avatar mobile
const AvatarSelectMobile = ({
  avatarList,
  open,
  onClose,
  t,
  setChosenAvatar,
  handleSaveAvatar,
  chosenAvatar,
  onCloseMenu,
  modalRef,
}) => {
  const styleButton = {
    maxWidth: "390px",
    width: "342.749px",
    padding: "7.55px 18.119px",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    fontWeight: 700,
    fontSize: "16px",
    borderRadius: "12px",
    textTransform: "uppercase",
    cursor: "pointer",
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
          padding: "16px",
          minHeight: "70vh",
          alignItems: "center",
        },
      }}
    >
      <AvatarHeader
        onClose={onClose}
        title={t("global.personalize_your_profile")}
      />
      <AvatarOptions
        chosenAvatar={chosenAvatar}
        avatarList={avatarList}
        onSelect={(img) => setChosenAvatar(img)}
        onCloseMenu={onCloseMenu}
      />
      <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <Button
          fullWidth
          disabled={!chosenAvatar} //Desabilita o botão para prevenir que o usuário clique em "Salvar" sem ter escolhido um avatar.
          onClick={handleSaveAvatar}
          sx={{
            margin: "20px 0 8px 0",
            backgroundColor: "#662d91",
            color: "white",
            border: "none",
            ...styleButton,
            "&.Mui-disabled": {
              backgroundColor: "#ccc",
              color: "#888",
            },
          }}
        >
          {t("global.save")}
        </Button>
        <Button
          sx={{
            color: "#662d91",
            border: "solid 1px #662d91",
            ...styleButton,
          }}
          onClick={() => {
            onClose();
            modalRef?.current?.nextModal(0);
          }}
        >
          {t("global.close")}
        </Button>
      </Box>
    </Drawer>
  );
};

export default AvatarSelectMobile;
